"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state = [], action) => {
    switch (action.type) {
        case 'DEVICE_LIST_UPLOAD_SUCCESS':
            return [action.deviceList, ...state];
        case 'FETCH_DEVICE_LISTS_SUCCESS':
            return action.deviceLists;
        default:
            return state;
    }
};
exports.getDeviceLists = (state) => state;
